import { render, staticRenderFns } from "./TopHoldingsToggle.vue?vue&type=template&id=400d7eb3&scoped=true&"
import script from "./TopHoldingsToggle.vue?vue&type=script&lang=js&"
export * from "./TopHoldingsToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400d7eb3",
  null
  
)

export default component.exports